<template>
  <div clas="cotton-inspection-device-card">
    <div class="cotton-inspection-device-card_header" :style="{ backgroundColor: stateColor }">
      <span>{{ data.name }} ({{ stateText }})</span>
      <MBatteryInfo :batteryPercent="batteryPercent" :isCharging="isCharging" />
    </div>
    <div class="cotton-inspection-device-card_content">
      <div class="cotton-inspection-device-card_content-left">
        <span class="iconfont icon-position-base" @click="locateTo(data)"></span>
      </div>
      <div class="cotton-inspection-device-card_content-right">
        <el-button
          class="cotton-button"
          type="primary"
          @click.stop="openDeviceInfoWindow"
          size="small"
        >
          设备信息
        </el-button>
        <el-button
          v-if="authMenu['01021105']"
          class="cotton-button"
          type="primary"
          :disabled="isOffline(data)"
          @click.stop="openParamsSettingsWindow"
          size="small"
        >
          参数调整
        </el-button>
        <el-button
          class="cotton-button"
          type="primary"
          :disabled="isOffline(data)"
          @click.stop="openAlgoParamsSettingsWindow"
          size="small"
          v-if="authMenu['01021102']"
        >
          算法参数调整
        </el-button>
        <el-button
          class="cotton-button"
          type="primary"
          :disabled="isOffline(data)"
          @click.stop="openAlgoConfigWindow"
          size="small"
          v-if="authMenu['01021102']"
        >
          算法配置
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty } from '@/utils/is';
import { cottonResultStateUtils } from '@/views/cotton/monitor/utils/status';
import MBatteryInfo from '@/components/mBatteryInfo/index.vue';
import {
  openCD602ParamsSettingWindow,
  openCD602AlgoParamsSettingsWindow,
  openDeviceInfoPopover,
  openCD602AlgoConfigWindow
} from '@/views/cotton/monitor/utils/contextMenu';
import { getDeviceUpgradeParams } from '@/api/deviceUpgrade';
import { isOffline } from '@/utils/deviceUtils/state';

export default {
  components: { MBatteryInfo },
  inject: ['locateTo'],
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isOffline
    };
  },
  computed: {
    stateColor() {
      const state = isEmpty(this.data.state) ? -1 : this.data.state;
      const option = cottonResultStateUtils.getOption(state);

      return option.color;
    },
    stateText() {
      const state = isEmpty(this.data.state) ? -1 : this.data.state;

      return cottonResultStateUtils.getStateText(state);
    },
    hasBattery() {
      return !isEmpty(this.data.batteryPercent);
    },
    batteryPercent() {
      return this.data.batteryPercent || 0;
    },
    isCharging() {
      return `${this.data.isCharging}` === '1';
    }
  },
  methods: {
    async openDeviceInfoWindow() {
      // TODO 打开设备信息弹窗
      const res = await getDeviceUpgradeParams(this.data.sn);
      console.log(res);

      openDeviceInfoPopover(this.data, () => {
        console.log('更新');
      });
    },
    openParamsSettingsWindow() {
      openCD602ParamsSettingWindow({ sn: this.data.sn });
    },
    openAlgoParamsSettingsWindow() {
      openCD602AlgoParamsSettingsWindow({ sn: this.data.sn });
    },
    openAlgoConfigWindow() {
      openCD602AlgoConfigWindow({ sn: this.data.sn });
    }
  }
};
</script>

<style lang="scss">
.cotton-inspection-device-card {
  --header-height: 40px;

  &_header {
    height: var(--header-height);
    line-height: var(--header-height);
    padding: 0 20px;
    color: var(--cotton-device-card-header-text);
    background: #4ef99d;
    border-radius: 10px 10px 0 0;

    display: flex;
    justify-content: space-between;
  }

  &_content {
    --border-color: var(--cotton-device-card-content-border);

    display: flex;
    align-items: center;
    height: calc(100% - var(--header-height));
    border: 1px solid var(--border-color);
    border-radius: 0 0 10px 10px;

    &-left {
      width: 30%;
      border-right: 1px solid var(--border-color);
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      .iconfont {
        color: var(--cotton-device-card-position-icon);
        font-size: 38px;

        cursor: pointer;
      }
    }

    &-right {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      gap: 10px;

      width: 70%;

      padding: 5px 0;

      .el-button {
        margin-left: 0 !important;
      }
    }
  }
}
</style>
